import t from "styled-components";
import e from "../../../utils/colors.js";
const l = t.nav`
  box-sizing: border-box;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  flex-wrap: nowrap;
`, a = t.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  &:before {
    content: '';
    display: block;
    height: 40px;
    width: 0px;
    border-right: 1px solid ${e.darkGrey10};
  }

  &:last-child {
    &:after {
      content: '';
      display: block;
      height: 40px;
      width: 0px;
      border-right: 1px solid ${e.darkGrey10};
    }
  }
`, s = t.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 38px;
  text-decoration: none;
  background-color: transparent;
  border: none;

  font-family: inherit;
  font-size: 1rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.15;
  letter-spacing: -0.4px;

  color: ${(o) => {
  const { $isActive: r } = o;
  return r ? e.orange : e.blueGrey;
}};

  &:focus-visible {
    outline: none;
  }

  svg {
    margin-left: 1rem;

    path {
      fill: ${(o) => {
  const { $isActive: r } = o;
  return r ? e.orange : e.blueGrey;
}};
    }
  }

  &:hover,
  &:focus {
    cursor: pointer;

    color: ${e.orange};

    svg {
      path {
        fill: ${e.orange};
      }
    }
  }

  &[aria-expanded="true"] {
    svg {
      transform: rotate(180deg);
    }
  }
`, c = t.span`
  font-size: 1rem;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.15;
  letter-spacing: -0.4px;
`;
export {
  c as LinkText,
  a as NavItem,
  s as NavLink,
  l as TopLevelNav
};
